module.exports = __webpack_public_path__ + "img/66000.4d9ff614.jpg";